﻿import { api } from '@cwd/lib/main';

export interface DomainWhitelist {
    DomainWhitelistId?: string;
    Domain: string;
}

export async function getAll(): Promise<DomainWhitelist[]> {
    return api.get('/DomainWhitelist');
}

export async function createDomainWhitelist(domainWhitelist: DomainWhitelist): Promise<void> {
    return api.post('/DomainWhitelist', domainWhitelist);
}

export async function deleteDomainWhitelist(domainWhitelist: DomainWhitelist): Promise<void> {
    return api.delete('/DomainWhitelist', domainWhitelist);
}
